import { dayAndTime } from "./Dates.mjs";
import { parseISO } from "date-fns";
import log from "loglevel";

export const bucketizeEvents = (earningsCalendar) => {
  log.trace("bucketizeEvents:", earningsCalendar);
  const result = {};
  earningsCalendar.forEach((event) => {
    const { conference_date } = event;
    const day = new Date(conference_date).toLocaleDateString();
    // log.trace("conference_date:", conference_date, "day:", day);
    const { time } = dayAndTime(new Date(conference_date));
    if (!(day in result)) {
      result[day] = {};
    }
    if (!(time in result[day])) {
      result[day][time] = {
        conferenceDate: new Date(conference_date),
        events: [],
      };
    }
    result[day][time].events.push(event);
    // log.trace("day, time:", day, time, event);
  });
  return result;
};

export const parseNewCalendarQueryResult = ({ siteStats }) => {
  const { events_by_day, published_events_by_day = [] } = siteStats;
  const countsByDay = {};
  const publishedCountsByDay = {};
  events_by_day.forEach((event) => {
    // log.trace("event.key_as_string:", event.key_as_string);
    const date = parseISO(event.key_as_string.substring(0, 23)); // Why this substring?  I forget...
    // log.trace("date:", date);
    // log.trace("event:", event, date.toDateString());
    countsByDay[date.toDateString()] = event.doc_count;
  });
  published_events_by_day.forEach((event) => {
    // log.trace("event.key_as_string:", event.key_as_string);
    const date = parseISO(event.key_as_string.substring(0, 23));
    // log.trace("date:", date);
    // log.trace("event:", event, date.toDateString());
    publishedCountsByDay[date.toDateString()] = event.doc_count;
  });
  return { countsByDay, publishedCountsByDay };
};
